<template>
<div class="modal" tabindex="-1" id="edit-lifearea-modal">
    <div class="modal-dialog  modal-lg">
        <div class="modal-content">
            <div class="modal-header bg-custom">
                <div class="row">
                    <p>Edit/Create your &nbsp;<h3> {{fsModel.life_area}} </h3>&nbsp; Life-Area</p>
                </div> <div class="row">
                <small  style="margin-left:2em; margin-right:2em;">(<strong>Instructions:</strong> For your <b>{{fsModel.life_area}} Life-Area</b>,
                   <br/> detail your Vision, your Plan to achieve your Vision,<br/> and how you will Measure the achievement of that Vision.)</small>
                <button type="button" @click="cancel" class="close" title="Close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
                </div>
            </div>
            <div class="modal-body">
                <div class="row" >
                    <div class="col">
                    <h2 class="bg-secondary text-center" v-if="fsModel" v-html="'<strong>Life Area:</strong> ' + fsModel.life_area"></h2>
                    <!-- <form method="post" action="/fself/setup/saveupdate">
                        <input type="hidden" v-model="csrf_token" name="csrf_token" />
                        <strong>My Vision:</strong> <div id="visInputID"></div>
                        <strong>My Plan:</strong><div id="planInputID"></div>
                        <strong>My Measure:</strong><div id="measureInputID"></div>
                    </form> -->
                    <div style="visibility:block;">
                    <h5 class="modal-title text-bold">Vision:</h5>
                    <visionInput ref="vizInp"
                        :api-key="apikey"
                        cloud-channel="6"
                        :disabled=false
                        id="visInputID"
                        :init= "getInitMenuPlugins()"
                        :initial-value="fsModel.vision"
                        :inline=false
                        model-events= ""
                        plugins=""
                        tag-name="div"
                        toolbar=""
                        value=""
                        name="vision"
                        v-model="fsModel.vision"
                    />
                    <h5 class="modal-title text-bold">Standards &amp; Plan:</h5>
                    <planInput  ref="planInp"
                        :api-key="apikey"
                        cloud-channel="6"
                        :disabled=false
                        id="planInputID"
                        :init= "getInitMenuPlugins()"
                        :initial-value="fsModel.plan"
                        :inline=false
                        model-events= ""
                        plugins=""
                        tag-name="div1"
                        toolbar=""
                        value=""
                        v-model="fsModel.plan"
                        name="plan">
                    </planInput>
                    <h5 class="modal-title text-bold">Measure:</h5>
                    <measureInput  ref="mezInp"
                        :api-key="apikey"
                        cloud-channel="6"
                        :disabled=false
                        id="measureInputID"
                        :init= "getInitMenuPlugins()"
                        :initial-value="fsModel.measure"
                        :inline=false
                        model-events= ""
                        plugins=""
                        tag-name="div2"
                        toolbar=""
                        name="measure"
                        v-model="fsModel.measure"
                        value="">
                    </measureInput>
                    </div>
 <button class="btn btn-lg btn-warning float-right mx-2 my-2" @click="cancel">Close</button>
 <button class="btn btn-lg btn-primary float-right  mx-2 my-2" @click="saveAction">Save All</button>
                    </div>
                </div>
Last updated: {{fsModel.updated_at}}
<!-- {{this.$refs.vizInp.value}} {{this.$refs.planInp.value}} {{this.$refs.mezInp.value}} -->
            </div></div></div></div>

</template>

<script>
import axios from 'axios';
import Swal from 'sweetalert2';
import EventBus from '../../../event-bus';
import Editor from '@tinymce/tinymce-vue';


import { v4 as uuidv4 } from 'uuid';

export default {
    components: {
    visionInput: Editor,
    planInput: Editor,
     measureInput: Editor,

     },
    name: "FutureMeLifeArea",
    data() {
        return {
            csrf_token: document.head.querySelector('meta[name="csrf-token"]').getAttribute('content'),
            userinfo:'',
            alltemplates: [],
            fsModel:{},
            id:'',
        }
    },

    props: {
        userdata:'',
        templates:[],
        apikey:'',
    },
    mounted() {
          this.userinfo = JSON.parse(this.userdata);
//   this.alltemplates = JSON.parse(this.templates);
        EventBus.$on('populateModal', (data) => {
            this.modalReset();
            var temp = this.getTemplate(data.life_area);
            this.fsModel = Object.assign({}, temp);
            $('div#edit-lifearea-modal').modal('show');
        });

        EventBus.$on('populateModal2', (data) => {
            this.fsModel = Object.assign({}, data.model);
            this.id = this.fsModel.id;
            $('div#edit-lifearea-modal').modal('show');
        });

    },


    methods: {
         getGUID() {
            var guid = uuidv4();
            // console.log("GUID: " + guid);
            return guid;
        },
        modalReset() {
            //set all fields to blank
        },
        cancel() {
            console.log("Cancel close FSLifeArea");
            $('div#edit-lifearea-modal').modal('hide');
            EventBus.$emit('refreshParentPage');
            // location.reload();
        },
        getTemplate(life_area) {
             console.log("Looking for template with id " + life_area);
            return this.templates.find((template) =>{
                    // console.log(life_area + ' : '+ template.life_area);
                if(template.life_area == life_area) {
                    // console.log("Found template...");
                    return template;
                }
            });
        },
        getInitMenuPlugins() {
            return {
                height: 200,
                menubar: false,
                plugins: [
                    'code table lists'
                ],
                toolbar:
                    'undo redo | formatselect | bold italic backcolor | \
                    alignleft aligncenter alignright alignjustify | \
                    bullist numlist outdent indent | removeformat | help'
            }
        },
        saveAction() {
            // console.log(this.$refs);
            //console.log(this.$refs.vizInp.value);
            // console.log(this.$refs.planInp.value);
            // console.log(this.$refs.mezInp.value);
            this.saveDetails();
        },

        saveDetails() {
            axios.post('/fself/setup/saveupdate', {
                user_id:this.userinfo.id,
                id:this.id,
                life_area:this.fsModel.life_area,
                vision:this.fsModel.vision,
                plan:this.fsModel.plan,
                measure:this.fsModel.measure,
            })
            .then(res => {
                this.loading = false;
                this.success = true;
                this.message = res.data.message;
                this.updateToast(this.message, 4000);
                console.error(res.data.message);
            })
            .catch(err => {
                // this.loading = false;
                // this.failure = true;
                // this.success = false;

            })
            .finally(()=> {
                // location.reload();
            });

        },
        updateToast(message, timer = 2000, icon='success') {
            const Toast = Swal.mixin({
                position: 'center',
                width: 500,
                showConfirmButton: true,
            });
            Toast.fire({
                icon: icon,
                title: message
            });
        },

    },
    computed: {
    },
}
</script>
<style>
.bg-custom{
    background: #449acb;
color: #fff;
}
</style>
